module.exports = __webpack_public_path__ + "static/media/Regression.5cf179f9.svg";